module.exports = __webpack_public_path__ + "images/empty-304c8f9fdd.png";